<template>
	<v-dialog :fullscreen="isMobile" v-if="aboutUsOpen" v-model="aboutUsOpen" max-width="700px" scrollable transition="dialog-transition">
		<v-card raised>
			<v-card-title class="headline modal__title">
				<button type="button" class="btn-flat-icon--dark" @click="aboutUsOpen=false"><v-icon large>fal fa-times</v-icon></button>
			</v-card-title>
			<v-card-text class="modal__card-text basic-modal-padding">
				<div style="color: #666; font-size: 0.9em;">
					<h2 class="mb-4" style="font-size: 2.0em;">What is WRKPRTY?</h2>
					<p>WRKPRTY is a platform that enables home-based and remote workers to host or attend a social co-working event (a “work party”) any place, any time.</p>
					<p>Reserve a seat in one-click on your phone, show up, be introduced, and work alongside a small group of dynamic professionals to maximize your productivity, be inspired, network, make friends, share, and collaborate.</p>
					<p>Best of all, you get real life high-fives (not just emojis) for all the awesome you do.</p>
					<p>WRKPRTY is for professional consultants, employees, entrepreneurs, freelancers, even those “between jobs”; anyone conducting business via laptop computer.</p>
					<p>It’s time to celebrate, PRTYPPL … work is fun (again)!</p>
					<p>Have a question? <a @click="setModalOpen({prop: 'contactForm', value: true})">Contact Us!</a></p>
					<p>Thanks for your support! We look forward to meeting you.</p>
					<p>
						Aidan Makepeace<br>
						Founder @ wrkprty
					</p>
				</div>
				<div>
					<img class="event-page-flat-logo mb-3 mt-3" src="/static/images/wrkprty-flattened-logo.png" alt="">
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'AboutUsModal',
	methods: {
		...mapActions(['setModalOpen'])
	},
	computed: {
		...mapGetters(['getModalProp']),
		aboutUsOpen: {
			get() {
				return this.getModalProp('aboutUsModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'aboutUsModal', value: val })
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
